import React from 'react';
import PropTypes from 'prop-types';
import PrototypeSmtStencil from './product_parameters/PrototypeSmtStencil';
import FramedSmtStencil from './product_parameters/FramedSmtStencil';
import FramelessSmtStencil from './product_parameters/FramelessSmtStencil';

const ProductParameters = (props) => {
  const { product } = props;
  if (!product) return null;
  const selectedProduct = product || Spree.stencils_info[0];

  let ProductForm = PrototypeSmtStencil;

  if (selectedProduct.id === 38) ProductForm = FramedSmtStencil;
  if (selectedProduct.id === 47) ProductForm = FramelessSmtStencil;

  return (
    <ProductForm
      {...props}
      product={selectedProduct} />
  );
}

export default ProductParameters;
